import { elementsTransition, GamePackPaletteOptions } from '@/utils/gamePacks';
import SelectedDynamicShape from './BackgroundElements/SelectedDynamicShape';
import SelectedFixedShape from './BackgroundElements/SelectedFixedShape';
import clsx from 'clsx';

export default function SelectedBackground({ palette }: { palette: GamePackPaletteOptions }) {
  return (
    <div
      className={clsx(
        'h-full w-full absolute z-0 left-0 top-0 rounded-xs overflow-hidden',
        `${palette.colors.selection}`
      )}
    >
      <SelectedDynamicShape
        className="absolute bottom-0 left-0 origin-bottom-left"
        color={palette.colors.inverse}
        initial={{ scale: 0.5 }}
        animate={{ scale: 1 }}
        transition={elementsTransition}
      />
      <SelectedFixedShape
        className="absolute bottom-0 right-0 origin-bottom-right"
        initial={{ scale: 0.5 }}
        animate={{ scale: 1 }}
        transition={elementsTransition}
      />
    </div>
  );
}
